import React, { useState, useEffect } from 'react';
import {
  Container,
  TextField,
  Button,
  Box,
  Modal,
  Paper,
  Tooltip,
  Typography
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

const EditInterestLevel = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [InterestLevelName, setInterestLevelName] = useState('');
  const { InterestLevelId } = useParams();
  const navigate = useNavigate();

  // Static InterestLevel data
  const staticInterestLevelData = [
   { InterestLevelId: 1, InterestLevelName: 'Open' },
    { InterestLevelId: 2, InterestLevelName: 'Ready to Enroll' },
    { InterestLevelId: 3, InterestLevelName: 'Lost Lead' },
    { InterestLevelId: 4, InterestLevelName: 'Attempt (Yet to reach)' },
    { InterestLevelId: 5, InterestLevelName: 'Admission Done' },
    { InterestLevelId: 6, InterestLevelName: 'Connected (In Discussion)' },
    { InterestLevelId: 7, InterestLevelName: 'Proposed' },
    { InterestLevelId: 8, InterestLevelName: 'Negotiating' },
  ];

  useEffect(() => {
    // Find the InterestLevel to edit based on InterestLevelId
    const InterestLevel = staticInterestLevelData.find(
      InterestLevel => InterestLevel.InterestLevelId === parseInt(InterestLevelId)
    );
    if (InterestLevel) {
      setInterestLevelName(InterestLevel.InterestLevelName);
    } else {
      alert('InterestLevel not found');
    }
  }, [InterestLevelId]);

  const handleUpdate = () => {
    if (InterestLevelName) {
      console.log('Updated InterestLevel:', InterestLevelName);
      setShowSuccessModal(true);
    } else {
      alert('Please enter a InterestLevel name');
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container mt={4}>
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)',
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit InterestLevel
        </Typography>
      </Box>

      <Paper elevation={3} style={{ 
        padding: 16, 
        width: '100%', 
        margin: 'auto', 
        marginTop: 6, 
        backgroundColor: '#f8fdfeff' 
      }}>
        <div>
          <TextField
            label="InterestLevel Name"
            variant="outlined"
            fullWidth
            value={InterestLevelName}
            onChange={(e) => setInterestLevelName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!InterestLevelName && "Enter InterestLevel Name"} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{ 
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!InterestLevelName}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              InterestLevel Updated ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              InterestLevel Updated Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditInterestLevel;